import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import { connect } from 'react-redux';

import API from '@api/index';
import { mapDispatchProps, mapStateToProps } from 'store/store';
import { getCookie } from 'helpers/common';
import { DOMAINS, getCurrentDomain } from '@constants/domains/domains';

const MetaPixelEventTracker = (props) => {
  const DOMAINS__PIXEL_ID__MAP = {
    [DOMAINS.GLOVV_KR]: process.env.META_PIXEL_ID_GLOVV_KR,
  }

  const location = useLocation();
  const pixelId = useRef(null);

  useEffect(() => {
    if (pixelId.current == null) {
      const domainPixelId = DOMAINS__PIXEL_ID__MAP[getCurrentDomain()]
      if (domainPixelId != null && domainPixelId != '') {
        pixelId.current = domainPixelId
        ReactPixel.init(pixelId.current)
      }
    }
    
    if (pixelId.current != null) {
      ReactPixel.pageView();
      requestFacebookAdsEventViewContent();
    }
  }, [location, props.brand?.name]);

  async function requestFacebookAdsEventViewContent () {
    try {
      await API.FacebookAds.event({
        eventName: API.FacebookAds.EVENT__EVENT_NAMES.VIEW_CONTENT,
        sourceUrl: window.location.href,
        fbp: getCookie('_fbp'),
        fbc: getCookie('_fbc'),
        name: props.brand?.name ?? undefined,
      })
    } catch (e:any) {
      console.error('[requestFacebookAdsEventViewContent]', e);
    }
  }

  return <div id="meta-pixel-event-tracker"/>;
}

export default connect(mapStateToProps, mapDispatchProps)(MetaPixelEventTracker)